var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Accounting Icon",
    d: "M4 45.5C2.067 45.5 0.5 43.933 0.5 42V20.5H16C18.4853 20.5 20.5 18.4853 20.5 16V0.5H23H42C43.933 0.5 45.5 2.067 45.5 4V23V42C45.5 43.933 43.933 45.5 42 45.5H4ZM16.2273 1.20711V12.7273C16.2273 14.6603 14.6603 16.2273 12.7273 16.2273H1.20711L8.71719 8.71719L16.2273 1.20711Z",
    fill: "#C7CCCA",
    stroke: "#C7CCCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccounting);
export default __webpack_public_path__ + "static/media/icon_accounting.9726e109990a02f0ec113a9344fc4b70.svg";
export { ForwardRef as ReactComponent };